"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconCertificate = void 0;

var React = __importStar(require("react"));

exports.IconCertificate = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "32",
    height: "40",
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    d: "M0 0.909091V39.0909C0 39.5669 0.440517 40 0.924369 40H30.5043C30.988 40 31.4286 39.5669 31.4286 39.0909V0.909091C31.4286 0.433229 30.988 0 30.5043 0H0.924369C0.42068 0 0 0.498954 0 0.909091ZM1.84874 1.81818H29.5797V38.1817H1.84874V1.81818ZM6.38394 5.45454C5.90006 5.47763 5.47943 5.9304 5.50291 6.40629C5.52457 6.88214 5.98677 7.29583 6.47063 7.27271H24.958C25.4455 7.27983 25.895 6.8448 25.895 6.36363C25.895 5.88246 25.4455 5.44746 24.958 5.45454H6.47063C6.44174 5.45277 6.41286 5.45277 6.38397 5.45454H6.38394ZM6.38394 10.9091C5.90006 10.9322 5.47943 11.3849 5.50291 11.8608C5.52457 12.3367 5.98677 12.7504 6.47063 12.7273H24.958C25.4455 12.7344 25.895 12.2994 25.895 11.8182C25.895 11.337 25.4455 10.902 24.958 10.9091H6.47063C6.44174 10.9073 6.41286 10.9073 6.38397 10.9091H6.38394ZM19.8742 15.9091C16.0557 15.9091 12.9414 18.9719 12.9414 22.7273C12.9414 24.2507 13.4632 25.6516 14.328 26.7898V34.5451C14.328 35.1631 15.1115 35.6354 15.6712 35.3549L19.8742 33.2951L24.0772 35.3549C24.6369 35.6354 25.4204 35.1631 25.4204 34.5451V26.7898C26.2852 25.6516 26.8069 24.2507 26.8069 22.7273C26.8069 18.9719 23.6926 15.9091 19.8742 15.9091ZM6.38394 16.3636C5.90006 16.3867 5.47943 16.8395 5.50291 17.3154C5.52457 17.7912 5.98677 18.2049 6.47063 18.1818H11.0925C11.5799 18.1889 12.0295 17.7539 12.0295 17.2727C12.0295 16.7915 11.5799 16.3565 11.0925 16.3636H6.47063C6.44174 16.3619 6.41286 16.3619 6.38397 16.3636H6.38394ZM19.8742 17.7273C22.6925 17.7273 24.9582 19.9556 24.9582 22.7273C24.9582 25.4989 22.6925 27.7273 19.8742 27.7273C17.0559 27.7273 14.7901 25.4989 14.7901 22.7273C14.7901 19.9556 17.0559 17.7273 19.8742 17.7273ZM16.1767 28.48C17.2491 29.1511 18.5129 29.5454 19.8742 29.5454C21.2355 29.5454 22.4993 29.1511 23.5717 28.48V33.0683L20.293 31.4631C20.0348 31.3334 19.7135 31.3334 19.4553 31.4631L16.1767 33.0683L16.1767 28.48Z",
    fill: color
  }));
});